const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updateLeadField = async (leadId, fieldKey, value, role) => {
    const token = localStorage.getItem("token");

    const isNullUpdate = value === null;
    const normalizedValue = typeof value === "boolean" ? Number(value) : value;
    const formData = new FormData();
    formData.append("_method", "PATCH");
    if (!isNullUpdate) {
        formData.append(fieldKey, normalizedValue);
    }

    try {
        const response = await fetch(`${API_BASE_URL}/${role}/lead/leads/${leadId}`, {
            method: "POST", headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json", ...(isNullUpdate ? {"Content-Type": "application/json"} : {}),
            }, body: isNullUpdate ? JSON.stringify({_method: "PATCH", [fieldKey]: null}) : formData,
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('[updateLead] Ошибка обновления лида:', errorData);
            throw errorData

        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('[createLead] Ошибка сети:', error);
        throw error;
    }
};
